import React from "react";
import { ITabsListProps } from "./TabsList.types";
import { Tab, TabProps, Tabs, TabsProps, styled } from "@mui/material";
import { a11yProps } from "./utils";

export const TabsList: React.FC<ITabsListProps> = (props) => {
	const { selectedTab, varaint, tabs, onChange } = props;

	return (
		<CustomTabs
			value={selectedTab}
			variant={varaint}
			scrollButtons="auto"
			sx={props.sx}
			onChange={onChange}
			TabIndicatorProps={{ hidden: true }}
		>
			{tabs.map((tab, index) => {
				return (
					<CustomTab
						icon={tab.icon}
						iconPosition={tab.iconPosition || "start"}
						label={tab.label}
						disabled={tab.disabled}
						{...a11yProps(index)}
					/>
				);
			})}
		</CustomTabs>
	);
};

export const CustomTabs = styled((props: TabsProps) => <Tabs {...props} />)(
	({ theme }) => ({
		backgroundColor: `${
			theme.palette.mode === "dark" ? "rgba(73,82,88,0.12)" : "#fff"
		}`,
		boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",
		padding: "8px",
		borderRadius: "15px",
		"& .Mui-selected": {
			background: theme.palette.primary.main,
			color: "#fff !important",
			borderRadius: "15px",
		},
	})
);

export const CustomTab = styled((props: TabProps) => <Tab {...props} />)(
	({ theme }) => ({
		fontSize: "1rem",
		padding: "15px",
		fontWeight: 600,
	})
);
